import { render, staticRenderFns } from "./LibrisModal.vue?vue&type=template&id=6c8c0c92&scoped=true"
import script from "./LibrisModal.vue?vue&type=script&lang=js"
export * from "./LibrisModal.vue?vue&type=script&lang=js"
import style0 from "./LibrisModal.vue?vue&type=style&index=0&id=6c8c0c92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8c0c92",
  null
  
)

export default component.exports